(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a72"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a72"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4QZXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $388c1559104f9d81$export$2e2bcd8739ae039);

var $3DJrJ = parcelRequire("3DJrJ");
class $388c1559104f9d81$export$2e2bcd8739ae039 {
    constructor(){
        this.api = new (0, $3DJrJ.default);
    }
    async getBooks() {
        return await this.api.send("books");
    }
    async getBook(book) {
        return await this.api.send(`books/${book}`);
    }
}

});
parcelRegister("3DJrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a6844521cced45a$export$2e2bcd8739ae039);
class $2a6844521cced45a$export$2e2bcd8739ae039 {
    constructor(){
        this.setBaseUrl();
    }
    async send(endpoint, method = "GET", body = {}, header = {}) {
        const headers = {
            "Content-Type": "application/json",
            ...header
        };
        try {
            const response = await fetch(this.getRequestUrl(endpoint), {
                method: method,
                headers: headers
            });
            if (!response.ok) return false;
            const responseBody = await response.json();
            const responseHeaders = {};
            response.headers.forEach((value, key)=>{
                responseHeaders[key] = value;
            });
            return {
                body: responseBody,
                headers: responseHeaders
            };
        } catch (error) {
            return null;
        }
    }
    setBaseUrl(url = "") {
        if (!url) url = "https://biblia.parresia.com/wp-json/bible/v2";
        this.baseUrl = url;
    }
    getRequestUrl(endpoint) {
        return `${this.baseUrl}/${endpoint}`;
    }
    buildQueryParamns(paramns) {
        const searchParams = {};
        for(const key in paramns)if (Object.hasOwnProperty.call(paramns, key) && paramns[key]) searchParams[key] = paramns[key];
        return new URLSearchParams(searchParams).toString();
    }
}

});


parcelRegister("hbqxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8280da52599add5$export$2e2bcd8739ae039);

var $3DJrJ = parcelRequire("3DJrJ");
class $c8280da52599add5$export$2e2bcd8739ae039 {
    constructor(){
        this.api = new (0, $3DJrJ.default);
    }
    async getChapter(book, verse, search = false) {
        const params = this.api.buildQueryParamns({
            search: search
        });
        return await this.api.send(`chapter/${book}_${verse}/${params}`);
    }
}

});

parcelRegister("LnmGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $08e683ab134455ac$export$2e2bcd8739ae039);

var $3DJrJ = parcelRequire("3DJrJ");
class $08e683ab134455ac$export$2e2bcd8739ae039 {
    constructor(){
        this.api = new (0, $3DJrJ.default);
    }
    async getVerses(book, start, end, testament = false, search = false, page = false) {
        if (book) {
            const params = this.api.buildQueryParamns({
                search: search,
                page: page
            });
            if (start && end) {
                book = `${book}_${start}_${end}`;
                return await this.api.send(`chapter/${book}?${params}`);
            }
            return await this.api.send(`verses/${book}/?${params}`);
        } else return await this.search(search, testament, page);
    }
    async search(search, testament = false, page = false, perPage = false) {
        const params = this.api.buildQueryParamns({
            search: search,
            per_page: perPage,
            page: page,
            testament: testament
        });
        return await this.api.send(`verses/?${params}`);
    }
}

});

parcelRegister("3lHCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $27052a7d548ddbba$export$2e2bcd8739ae039);

var $3DJrJ = parcelRequire("3DJrJ");
class $27052a7d548ddbba$export$2e2bcd8739ae039 {
    constructor(){
        this.api = new (0, $3DJrJ.default);
        this.setBaseUrl();
    }
    async getMeditatedGospel(date) {
        return await this.api.send(`meditated_gospel/${date}`);
    }
    setBaseUrl() {
        const url = `${window.location.origin}/wp-json/espiritualidade-parresia`;
        this.api.setBaseUrl(url);
    }
}

});

class $0bfa6252c9fef6aa$export$2e2bcd8739ae039 {
    constructor(biblia){
        this.biblia = biblia;
    }
    initialize() {
        this.openTestamentSelect();
        this.setSelectedTestament();
        this.setDefaultTestamentOption();
    }
    openTestamentSelect() {
        const context = document.querySelector("#biblia-online #testament-filter");
        const select = document.querySelector("#biblia-online #testament-filter > .filter-select");
        const options = document.querySelector("#biblia-online #testament-filter > .filter-options");
        select.addEventListener("click", ()=>{
            options.classList.toggle("active");
        });
        options.addEventListener("click", (e)=>{
            if (e.target.classList.contains("option")) options.classList.remove("active");
        });
        document.addEventListener("click", (e)=>{
            if (!context.contains(e.target)) options.classList.remove("active");
        });
    }
    setSelectedTestament() {
        const options = document.querySelectorAll("#biblia-online #testament-filter > .filter-options .option");
        options.forEach((option)=>{
            option.addEventListener("click", ()=>{
                this.selectTestamentOption(option);
            });
        });
    }
    setDefaultTestamentOption() {
        const defaultOption = document.querySelector('#biblia-online #testament-filter > .filter-options .option[data-value="default"]');
        this.selectTestamentOption(defaultOption);
    }
    selectTestamentOption(option) {
        if (!option.classList.contains("selected")) {
            const label = document.querySelector("#biblia-online .selected-label");
            label.innerText = option.innerText;
            this.clearSelectedTestament();
            this.filterTestamentBooks(option.getAttribute("data-value"));
            option.classList.add("selected");
            this.setSelectedFilters(option);
        }
    }
    clearSelectedTestament() {
        const options = document.querySelectorAll("#biblia-online #testament-filter > .filter-options > div > .option");
        const selected = document.querySelector("#biblia-online #testament-filter > .filter-selected");
        selected.innerHTML = "";
        options.forEach((option)=>{
            option.classList.remove("selected");
        });
    }
    setSelectedFilters(selected) {
        if (selected.getAttribute("data-value") == "default") return;
        const section = document.querySelector("#biblia-online #testament-filter > .filter-selected");
        const div = document.createElement("div");
        const span = document.createElement("span");
        span.innerText = selected.innerText;
        const i = document.createElement("i");
        i.classList.add("fa-solid", "fa-xmark");
        i.addEventListener("click", ()=>{
            selected.classList.remove("selected");
            div.remove();
            this.setDefaultTestamentOption();
        });
        div.appendChild(span);
        div.appendChild(i);
        section.innerHTML = "";
        section.appendChild(div);
    }
    handlerTestamentBooksFilter(testament) {
        const options = document.querySelectorAll("#biblia-online #testament-filter > .filter-options > div > .selected");
        if (options.length) this.filterTestamentBooks(testament);
        else this.filterTestamentBooks();
    }
    filterTestamentBooks(testament = false) {
        const books = document.querySelectorAll("#biblia-online .list > div");
        books.forEach((book)=>{
            if (!testament || testament === "default") book.classList.remove("filtered");
            else if (book.getAttribute("data-testament") === testament) book.classList.remove("filtered");
            else book.classList.add("filtered");
        });
    }
    getImagesUrl() {
        const url = document.querySelector("#parresia-image-url");
        return url?.value || "";
    }
}


class $3597ba39cfd0154a$export$2e2bcd8739ae039 {
    constructor(biblia){
        this.biblia = biblia;
    }
    initialize() {
        this.setSearchBooks();
    }
    setSearchBooks() {
        const input = document.querySelector("#biblia-online #search-books");
        input.addEventListener("input", ()=>{
            const books = document.querySelectorAll("#biblia-online .list > div");
            books.forEach((book)=>{
                const name = book.querySelector(".book > span");
                if (!book.classList.contains("filtered")) {
                    book.classList.remove("deactive");
                    if (!name.innerText.toUpperCase().includes(input.value.toUpperCase())) book.classList.add("deactive");
                }
            });
        });
    }
}


class $87e2f94c1d800966$export$2e2bcd8739ae039 {
    constructor(biblia){
        this.biblia = biblia;
    }
    setBooksData(data) {
        const hidden = document.querySelector("#biblia-online #parresia-biblia-books");
        if (hidden) hidden.value = JSON.stringify(data);
    }
    createBook(list, book) {
        const name = this.createBookName(book.chapter);
        const icon = this.createBookDropdownIcon();
        const chapters = this.createBookChapters(book);
        const context = this.createBookContext(book, name, icon, chapters);
        list.appendChild(context);
        this.openBookContext(context);
        this.backToSideBar();
    }
    createBookName(name) {
        const bookName = document.createElement("span");
        bookName.innerText = name;
        return bookName;
    }
    createBookDropdownIcon() {
        const icon = document.createElement("i");
        icon.classList.add("fa-solid", "fa-chevron-down");
        return icon;
    }
    createBookContext(book, name, icon, chapters) {
        const bookContext = document.createElement("div");
        bookContext.setAttribute("data-testament", book.meta.testament);
        bookContext.setAttribute("data-book", JSON.stringify(book));
        const div = document.createElement("div");
        div.classList.add("book");
        div.appendChild(name);
        div.appendChild(icon);
        bookContext.appendChild(div);
        bookContext.appendChild(chapters);
        return bookContext;
    }
    createBookChapters(book) {
        const chapters = document.createElement("div");
        chapters.classList.add("chapters");
        for(let index = 1; index <= book.chapter_count; index++){
            const chapter = document.createElement("span");
            chapter.classList.add("chapter");
            chapter.innerText = index;
            chapter.setAttribute("data-chapter", index);
            chapter.setAttribute("data-book", book.slug);
            chapter.addEventListener("click", ()=>{
                this.biblia.chapter.setChapter(book, index);
                this.selectChapter(chapter);
                this.changeMobileView();
            });
            chapters.appendChild(chapter);
        }
        return chapters;
    }
    selectChapter(chapter) {
        const selectedBooks = document.querySelectorAll("#biblia-online .list > .selected");
        selectedBooks.forEach((element)=>element.classList.remove("selected"));
        const selectedChapters = document.querySelectorAll("#biblia-online .list > div > .chapters .chapter.selected");
        selectedChapters.forEach((element)=>element.classList.remove("selected"));
        const parent = chapter.parentElement.parentElement;
        parent.classList.add("selected");
        chapter.classList.add("selected");
    }
    backToSideBar() {
        const button = document.querySelector("#biblia-online > .base > .content .show-sidebar");
        button.addEventListener("click", ()=>{
            this.changeMobileView();
        });
    }
    changeMobileView() {
        const content = document.querySelector("#biblia-online > .base > .sidebar");
        const sidebar = document.querySelector("#biblia-online > .base > .content");
        content.classList.toggle("mobile-deactive");
        sidebar.classList.toggle("mobile-deactive");
    }
    openBookContext(context) {
        context.addEventListener("click", (e)=>{
            if (context.contains(e.target) && !e.target.classList.contains("chapter") && !e.target.classList.contains("chapters")) context.classList.toggle("selected");
        });
        const list = context.parentElement;
        list.addEventListener("click", (e)=>{
            if (!context.contains(e.target)) context.classList.remove("selected");
        });
    }
    getImagesUrl() {
        const url = document.querySelector("#parresia-image-url");
        return url?.value || "";
    }
}



var $4QZXM = parcelRequire("4QZXM");

var $hbqxJ = parcelRequire("hbqxJ");
class $f54c35483bceabdf$export$2e2bcd8739ae039 {
    constructor(content, increaseButton, decreaseButton){
        this.handleFontControllers(content, increaseButton, decreaseButton);
    }
    increaseFontSize(content) {
        let currentFontSize = parseFloat(window.getComputedStyle(content, null).getPropertyValue("font-size"));
        if (currentFontSize < 22) content.style.fontSize = currentFontSize + 1 + "px";
    }
    forceFontSize(content, value = 16) {
        let currentFontSize = parseFloat(window.getComputedStyle(content, null).getPropertyValue("font-size"));
        if (currentFontSize <= 22 && currentFontSize >= 8) content.style.fontSize = `${value}px`;
    }
    decreaseFontSize(content) {
        let currentFontSize = parseFloat(window.getComputedStyle(content, null).getPropertyValue("font-size"));
        if (currentFontSize > 8) content.style.fontSize = currentFontSize - 1 + "px";
    }
    handleFontControllers(content, increaseButton, decreaseButton) {
        content.querySelectorAll("*").forEach((child)=>{
            this.forceFontSize(child, 16);
        });
        increaseButton.addEventListener("click", ()=>{
            this.increaseFontSize(content);
            content.querySelectorAll("*").forEach((child)=>{
                this.increaseFontSize(child);
            });
        });
        decreaseButton.addEventListener("click", ()=>{
            this.decreaseFontSize(content);
            content.querySelectorAll("*").forEach((child)=>{
                this.decreaseFontSize(child);
            });
        });
    }
}


class $e27abdd7988dd336$export$2e2bcd8739ae039 {
    constructor(container){
        this.container = container;
    }
    setLoader() {
        this.unsetLoader();
        const loader = document.createElement("div");
        loader.classList.add("loader");
        this.container.appendChild(loader);
    }
    unsetLoader() {
        this.container.innerHTML = "";
    }
}


class $196c09a0d2ec095b$export$2e2bcd8739ae039 {
    constructor(content, leftCallback, rigthCallback){
        this.handleSwipe(content, leftCallback, rigthCallback);
    }
    handleSwipe(content, leftCallback, rightCallback, swipeEvent = true) {
        if (content) {
            let startX;
            if (!content.dataset.swipeEventAdded) {
                content.addEventListener("touchstart", (e)=>{
                    startX = e.touches[0].clientX;
                });
                content.addEventListener("touchend", (e)=>{
                    const endX = e.changedTouches[0].clientX;
                    const diffX = endX - startX;
                    if (Math.abs(diffX) > 150) {
                        if (diffX > 0) leftCallback();
                        else rightCallback();
                    }
                });
            }
            content.dataset.swipeEventAdded = swipeEvent;
        }
    }
}


class $f64844d873023a19$export$2e2bcd8739ae039 {
    constructor(biblia){
        this.biblia = biblia;
        this.handleNextChapter();
        this.handlePreviusChapter();
        this.fontControllers();
        this.handleChapterPicker();
    }
    setChapter(book, chapter = 1) {
        const content = document.querySelector("#biblia-online #content-display");
        content.className = "chapter-content";
        const api = new (0, $hbqxJ.default);
        const loader = new (0, $e27abdd7988dd336$export$2e2bcd8739ae039)(content);
        loader.setLoader();
        this.biblia.advancedSearch.deativeSearchResult();
        api.getChapter(book.slug, chapter).then((data)=>{
            loader.unsetLoader();
            if (data) {
                const body = data.body;
                this.createVerses(body, content);
                this.setChapterControllers(body[0].chapter, book.chapter_count);
                this.setChapterTitle(book.chapter);
                book.index = chapter;
                this.setContentBook(book);
                const chapterElemente = document.querySelector(`span[data-chapter="${chapter}"][data-book="${book.slug}"]`);
                this.biblia.books.selectChapter(chapterElemente);
                this.setChapterPiker(book, chapter);
                this.handleSwipeChapter();
            } else this.createVerses(false, content);
        });
    }
    setCapterLoader() {
        const content = document.querySelector("#biblia-online #content-display");
        content.innerText = "";
        const loader = document.createElement("div");
        loader.classList.add("loader");
        content.appendChild(loader);
    }
    setContentBook(book) {
        const contentBook = document.querySelector("#biblia-online #selected-book");
        contentBook.value = JSON.stringify(book);
    }
    setChapterControllers(chapterNumber) {
        const container = document.querySelector("#biblia-online #position-controllers > .position-controllers");
        container.classList.remove("search-page-controllers");
        container.classList.add("chapter-page-controllers");
        const currentTitle = document.querySelector("#biblia-online #position-description");
        currentTitle.innerText = "CAP\xcdTULO";
        const number = document.querySelector("#biblia-online #position-number");
        const next = parseInt(chapterNumber) + 1;
        number.setAttribute("data-context", "chapter");
        number.innerText = chapterNumber;
        const previusButton = document.querySelector("#biblia-online #previus-position");
        previusButton.setAttribute("data-position", chapterNumber - 1);
        const nextButton = document.querySelector("#biblia-online #next-position");
        nextButton.setAttribute("data-position", next);
    }
    setChapterTitle(title) {
        const book = document.querySelector("#biblia-online #content-title");
        book.innerText = title;
    }
    createVerses(verses, chapter) {
        chapter.innerHTML = "";
        if (verses) {
            const result = document.createElement("div");
            result.classList.add("chapter-result");
            verses.forEach((verse)=>{
                const div = document.createElement("div");
                div.classList.add("verse");
                const number = document.createElement("span");
                number.classList.add("verse-number");
                number.innerText = verse.number;
                div.appendChild(number);
                const content = document.createElement("div");
                content.classList.add("verse-content");
                div.appendChild(content);
                const text = document.createElement("span");
                text.innerText = verse.text;
                content.appendChild(text);
                result.appendChild(div);
            });
            chapter.appendChild(result);
        } else {
            const text = document.createElement("span");
            text.innerText = "Nenhum resultado encontrado.";
            chapter.appendChild(text);
        }
    }
    handleNextChapter() {
        const nextButton = document.querySelector("#biblia-online #next-position");
        nextButton.addEventListener("click", ()=>{
            this.getNextChapter();
        });
    }
    getNextChapter() {
        const nextButton = document.querySelector("#biblia-online #next-position");
        if (this.isChapterController()) {
            const next = parseInt(nextButton.getAttribute("data-position"));
            const book = document.querySelector("#biblia-online #selected-book");
            const data = JSON.parse(book.value);
            if (next > parseInt(data.chapter_count)) {
                this.changeSideBook(data, "next");
                return;
            }
            this.setChapter(data, next);
        }
    }
    handlePreviusChapter() {
        const previusButton = document.querySelector("#biblia-online #previus-position");
        previusButton.addEventListener("click", ()=>{
            this.getPreviusChapter();
        });
    }
    getPreviusChapter() {
        const previusButton = document.querySelector("#biblia-online #previus-position");
        if (this.isChapterController()) {
            let previus = previusButton.getAttribute("data-position");
            const book = document.querySelector("#biblia-online #selected-book");
            const data = JSON.parse(book.value);
            if (previus > 0) {
                this.setChapter(data, previus);
                return;
            }
            this.changeSideBook(data, "previus");
        }
    }
    isChapterController() {
        const current = document.querySelector("#biblia-online #position-number");
        return current.getAttribute("data-context") === "chapter";
    }
    handleSwipeChapter() {
        const content = document.querySelector("#biblia-online #content-display > .chapter-result");
        new (0, $196c09a0d2ec095b$export$2e2bcd8739ae039)(content, this.getPreviusChapter.bind(this), this.getNextChapter.bind(this));
    }
    changeSideBook(book, position) {
        const books = document.querySelector("#biblia-online #parresia-biblia-books");
        const data = JSON.parse(books.value);
        if (data) {
            for(const key in data)if (Object.hasOwnProperty.call(data, key)) {
                const item = data[key];
                if (item.slug === book.slug) {
                    let sideBook;
                    let chapter;
                    if (position === "next") {
                        sideBook = data[parseInt(key) + 1] || item;
                        chapter = sideBook === item ? sideBook.chapter_count : 1;
                    } else {
                        sideBook = data[key - 1] || item;
                        chapter = sideBook === item ? 1 : sideBook.chapter_count;
                    }
                    this.setChapter(sideBook, chapter);
                }
            }
        }
    }
    fontControllers() {
        const plus = document.querySelector("#biblia-online .font-controllers > .plus");
        const minor = document.querySelector("#biblia-online .font-controllers > .minor");
        const content = document.querySelector("#biblia-online #content-display");
        new (0, $f54c35483bceabdf$export$2e2bcd8739ae039)(content, plus, minor);
    }
    setChapterPiker(book, selectedChapter) {
        const chapters = document.querySelector("#biblia-online #position-controllers > .chapter-picker > .book-chapters");
        const bookTitle = document.querySelector("#biblia-online #position-controllers > .chapter-picker > .book-title > span");
        bookTitle.innerText = book.chapter;
        chapters.innerHTML = "";
        for(let index = 1; index <= book.chapter_count; index++){
            const chapter = document.createElement("span");
            chapter.classList.add("book-chapter");
            chapter.innerText = index;
            chapter.setAttribute("data-chapter", index);
            chapter.setAttribute("data-book", book.slug);
            if (selectedChapter == index) chapter.classList.add("selected");
            chapter.addEventListener("click", ()=>{
                chapter.classList.add("selected");
                setTimeout(()=>{
                    this.toogleChapterPicker();
                    this.setChapter(book, index);
                }, 100);
            });
            chapters.appendChild(chapter);
        }
    }
    handleChapterPicker() {
        const chapter = document.querySelector("#biblia-online #position-controllers > .position-controllers > .current-position");
        chapter.addEventListener("click", ()=>{
            if (chapter.parentElement.classList.contains("chapter-page-controllers")) this.toogleChapterPicker();
        });
    }
    toogleChapterPicker() {
        const chapter = document.querySelector("#biblia-online #position-controllers > .position-controllers > .current-position");
        const picker = document.querySelector("#biblia-online #position-controllers > .chapter-picker");
        picker.classList.toggle("open");
        chapter.classList.toggle("selected");
    }
}



var $LnmGi = parcelRequire("LnmGi");


class $dbe8ea63d0c9ab70$export$2e2bcd8739ae039 {
    constructor(biblia){
        this.biblia = biblia;
        this.showSearchSection();
        this.handleSearchForm();
        this.handleNextPage();
        this.handlePreviusPage();
        this.selectTestament();
        this.selectBook();
        this.selectChapterStart();
        this.clearSearchButton();
    }
    showSearchSection() {
        const button = document.querySelector("#biblia-online #toggle-advanced-search");
        button?.addEventListener("change", ()=>{
            const toggle = document.querySelector("#biblia-online #toggle-button");
            const form = document.querySelector("#biblia-online #search-form");
            toggle.classList.toggle("selected");
            if (form.classList.contains("open")) {
                form.classList.remove("open");
                setTimeout(()=>{
                    form.classList.add("deactive");
                }, 200);
            } else {
                form.classList.remove("deactive");
                setTimeout(()=>{
                    form.classList.add("open");
                }, 10);
            }
        });
    }
    selectTestament() {
        const testament = document.querySelector("#biblia-online #advanced-search-testament");
        testament.addEventListener("change", ()=>{
            this.setBooksSelect();
        });
    }
    selectBook() {
        const books = document.querySelector("#biblia-online #advanced-search-books");
        books.addEventListener("change", ()=>{
            if (books.value === "default") {
                this.resetChapterStartSelect();
                this.resetChapterEndSelect();
            } else this.setChapterStartSelect();
        });
    }
    selectChapterStart() {
        const chapterStart = document.querySelector("#biblia-online #advanced-search-chapter-start");
        chapterStart.addEventListener("change", ()=>{
            this.setChapterEndSelect();
        });
    }
    setChapterStartSelect() {
        const chapterStartSelect = document.querySelector("#biblia-online #advanced-search-chapter-start");
        const booksSelect = document.querySelector("#biblia-online #advanced-search-books");
        const selectedBook = booksSelect.options[booksSelect.selectedIndex];
        const length = parseInt(selectedBook.getAttribute("data-length"));
        chapterStartSelect.innerHTML = "";
        for(let index = 1; index <= length; index++){
            const option = document.createElement("option");
            option.setAttribute("value", index);
            option.innerText = `Cap\xedtulo ${index}`;
            chapterStartSelect.setAttribute("data-length", length);
            chapterStartSelect.appendChild(option);
        }
        this.setChapterEndSelect();
    }
    setChapterEndSelect() {
        const chapterStartSelect = document.querySelector("#biblia-online #advanced-search-chapter-start");
        const chapterEndSelect = document.querySelector("#biblia-online #advanced-search-chapter-end");
        const start = parseInt(chapterStartSelect.value);
        const length = parseInt(chapterStartSelect.getAttribute("data-length"));
        chapterEndSelect.innerHTML = "";
        for(let index = start; index <= length; index++){
            const option = document.createElement("option");
            option.setAttribute("value", index);
            option.innerText = `Cap\xedtulo ${index}`;
            chapterEndSelect.appendChild(option);
        }
        chapterEndSelect.value = length;
    }
    setBooksSelect() {
        const booksData = document.querySelector("#biblia-online #parresia-biblia-books");
        const booksSelect = document.querySelector("#biblia-online #advanced-search-books");
        const testamentSelect = document.querySelector("#biblia-online #advanced-search-testament");
        if (booksData.value) {
            const books = JSON.parse(booksData.value);
            this.resetBooksSelect();
            books.forEach((book)=>{
                if (testamentSelect.value === "default" || testamentSelect.value === book.meta.testament) {
                    const option = document.createElement("option");
                    option.setAttribute("value", book.slug);
                    option.setAttribute("data-length", book.chapter_count);
                    option.innerText = book.chapter;
                    booksSelect.appendChild(option);
                }
            });
        }
    }
    resetBooksSelect() {
        const booksSelect = document.querySelector("#biblia-online #advanced-search-books");
        booksSelect.innerHTML = "";
        const option = document.createElement("option");
        option.setAttribute("value", "default");
        option.innerText = "Todos os Livros";
        booksSelect.appendChild(option);
        this.resetChapterStartSelect();
        this.resetChapterEndSelect();
    }
    resetChapterStartSelect() {
        const chapterStart = document.querySelector("#biblia-online #advanced-search-chapter-start");
        chapterStart.innerHTML = "";
        const option = document.createElement("option");
        option.setAttribute("value", "default");
        option.innerText = "De";
        chapterStart.appendChild(option);
    }
    resetChapterEndSelect() {
        const chapterEnd = document.querySelector("#biblia-online #advanced-search-chapter-end");
        chapterEnd.innerHTML = "";
        const option = document.createElement("option");
        option.setAttribute("value", "default");
        option.innerText = "At\xe9";
        chapterEnd.appendChild(option);
    }
    changeMobileView() {
        const content = document.querySelector("#biblia-online > .base > .sidebar");
        const sidebar = document.querySelector("#biblia-online > .base > .content");
        content.classList.add("mobile-deactive");
        sidebar.classList.remove("mobile-deactive");
    }
    handleSearchForm() {
        const form = document.querySelector("#search-form");
        if (form) form.addEventListener("submit", (e)=>{
            e.preventDefault();
            const testament = document.querySelector("#advanced-search-testament");
            const testamentText = testament.options[testament.selectedIndex];
            const book = document.querySelector("#advanced-search-books");
            const bookText = book.options[book.selectedIndex];
            const start = document.querySelector("#advanced-search-chapter-start");
            const end = document.querySelector("#advanced-search-chapter-end");
            const content = document.querySelector("#advanced-search-input");
            this.searchRequest({
                term: content.value === "default" ? false : content.value,
                testament: testament.value === "default" ? false : testament.value,
                testamentText: testamentText.innerText,
                book: book.value === "default" ? false : book.value,
                bookText: bookText.innerText,
                start: start.value === "default" ? false : start.value,
                end: end.value === "default" ? false : end.value,
                currentPage: 1,
                previusPage: 1,
                nextPage: 2
            });
            this.changeMobileView();
        });
    }
    searchRequest(search) {
        const container = document.querySelector("#biblia-online #content-display");
        const api = new (0, $LnmGi.default)();
        const loader = new (0, $e27abdd7988dd336$export$2e2bcd8739ae039)(container);
        loader.setLoader();
        api.getVerses(search.book, search.start, search.end, search.testament, search.term, search.currentPage).then((data)=>{
            loader.unsetLoader();
            if (data) {
                const body = data.body;
                search.totalPages = data.headers["x-wp-totalpages"];
                search.total = data.headers["x-wp-total"];
                this.setSearchView(search, body);
                this.setSearchData(search);
                this.handleSwipePage();
            } else this.setSearchView(search);
        });
    }
    setSearchView(search, result = false) {
        const content = document.querySelector("#biblia-online #content-display");
        content.className = "search-content";
        const searchResult = document.createElement("div");
        searchResult.classList.add("search-result");
        content.appendChild(searchResult);
        this.setSearchTitle("Resultados");
        this.setSearchDescription(search, searchResult);
        this.setSearchControllers(search.currentPage);
        this.setResult(result, search, searchResult);
    }
    setSearchData(data) {
        const dataInput = document.querySelector("#search-data");
        dataInput.value = JSON.stringify(data);
    }
    setSearchTitle(title) {
        const element = document.querySelector("#biblia-online #content-title");
        element.innerText = title;
    }
    setSearchDescription(search, content) {
        const TestamentText = search.testamentText ? ` no ${search.testamentText},` : "";
        const bookText = search.bookText ? ` em ${search.bookText} ` : "";
        const rangeText = search.start && search.end ? `${search.start}-${search.end}` : "";
        const div = document.createElement("div");
        div.classList.add("search-description");
        const span = document.createElement("span");
        span.innerText = `Buscando o termo "${search.term}"${TestamentText}${bookText}${rangeText}.`;
        div.appendChild(span);
        this.showSearchResultSection(search);
        content.innerHTML = "";
        content.appendChild(div);
    }
    showSearchResultSection(search) {
        const resultSection = document.querySelector("#search-result");
        const result = document.querySelector("#search-result > div > .search-result-quantity");
        resultSection.classList.remove("deactive");
        let total = search.total ?? 0;
        if (total >= 0) result.innerText = `${total} Resultados foram encontrados`;
        else result.innerText = `${total} Resultado foi encontrado`;
    }
    clearSearchButton() {
        const reset = document.querySelector("#search-reset");
        reset.addEventListener("click", ()=>{
            this.resetSearch();
        });
    }
    resetSearch() {
        const current = document.querySelector("#biblia-online #selected-book");
        if (current.value) {
            const data = JSON.parse(current.value);
            this.biblia.chapter.setChapter(data, data.index);
        }
    }
    deativeSearchResult() {
        const resultSection = document.querySelector("#search-result");
        resultSection.classList.add("deactive");
    }
    setSearchControllers(currentPage) {
        const container = document.querySelector("#biblia-online #position-controllers > .position-controllers");
        container.classList.add("search-page-controllers");
        container.classList.remove("chapter-page-controllers");
        const currentTitle = document.querySelector("#biblia-online #position-controllers > .search-page-controllers > .current-position > div > .position-description");
        currentTitle.innerText = "P\xc1GINA";
        const current = document.querySelector("#biblia-online #position-controllers #position-number");
        current.setAttribute("data-context", "search");
        current.innerText = currentPage;
        const previusPage = document.querySelector("#biblia-online #previus-position");
        previusPage.setAttribute("data-position", parseInt(currentPage) - 1);
        const nextPage = document.querySelector("#biblia-online #next-position");
        nextPage.setAttribute("data-position", parseInt(currentPage) + 1);
    }
    setResult(verses, search, content) {
        if (!verses) {
            const text = document.createElement("span");
            text.innerText = "Nenhum resultado encontrado";
            content.appendChild(text);
            return;
        }
        verses.forEach((verse)=>{
            const book = this.getBookData(verse.chapter_slug.replace(/-\d+/, ""));
            const div = document.createElement("div");
            div.classList.add("search-verse");
            const container = document.createElement("div");
            container.classList.add("search-container");
            div.appendChild(container);
            const text = document.createElement("span");
            text.innerHTML = this.contrastSearchTerm(verse.text, search.term);
            text.classList.add("font-size-15", "search-text");
            text.setAttribute("data-size", "15");
            container.appendChild(text);
            const info = document.createElement("span");
            info.innerText = `${book.chapter} ${verse.chapter}, ${verse.number}`;
            info.classList.add("font-size-15", "search-info");
            info.setAttribute("data-size", "15");
            container.appendChild(info);
            const chapter = document.createElement("span");
            chapter.innerText = "Ir para o cap\xedtulo";
            chapter.classList.add("font-size-15", "search-book-link");
            chapter.setAttribute("data-size", "15");
            chapter.addEventListener("click", ()=>{
                this.biblia.chapter.setChapter(book, verse.chapter);
            });
            container.appendChild(chapter);
            content.appendChild(div);
        });
    }
    getBookData(slug) {
        const contentBook = document.querySelector("#biblia-online #parresia-biblia-books");
        const data = JSON.parse(contentBook.value);
        let book;
        data.forEach((item)=>{
            if (item.slug && slug.includes(item.slug)) book = item;
        });
        return book;
    }
    contrastSearchTerm(verse, term) {
        const regex = new RegExp(term, "gi");
        return verse.replace(regex, (match)=>`<i>${match}</i>`);
    }
    isSearchController() {
        const current = document.querySelector("#biblia-online #position-number");
        return current.getAttribute("data-context") === "search";
    }
    handleNextPage() {
        const nextButton = document.querySelector("#biblia-online #next-position");
        nextButton.addEventListener("click", ()=>{
            this.getNextPage();
        });
    }
    getNextPage() {
        const nextButton = document.querySelector("#biblia-online #next-position");
        if (this.isSearchController()) {
            const next = parseInt(nextButton.getAttribute("data-position"));
            const search = document.querySelector("#biblia-online #search-data");
            const data = JSON.parse(search.value);
            if (data.totalPages > next) {
                data.previusPage = data.previusPage + 1;
                data.currentPage = data.currentPage + 1;
                data.nextPage = data.nextPage + 1;
                this.searchRequest(data);
            }
        }
    }
    handlePreviusPage() {
        const previusButton = document.querySelector("#biblia-online #previus-position");
        previusButton.addEventListener("click", ()=>{
            this.getPreviusPage();
        });
    }
    getPreviusPage() {
        const previusButton = document.querySelector("#biblia-online #previus-position");
        if (this.isSearchController()) {
            let previus = previusButton.getAttribute("data-position");
            const search = document.querySelector("#biblia-online #search-data");
            const data = JSON.parse(search.value);
            if (previus > 0) {
                data.previusPage = data.previusPage - 1;
                data.currentPage = data.currentPage - 1;
                data.nextPage = data.nextPage - 1;
                this.searchRequest(data);
            }
        }
    }
    handleSwipePage() {
        const content = document.querySelector("#biblia-online #content-display > .search-result");
        new (0, $196c09a0d2ec095b$export$2e2bcd8739ae039)(content, this.getPreviusPage.bind(this), this.getNextPage.bind(this));
    }
}


class $e39be4a8c4aa2412$export$2e2bcd8739ae039 {
    constructor(){
        this.books = new (0, $87e2f94c1d800966$export$2e2bcd8739ae039)(this);
        this.chapter = new (0, $f64844d873023a19$export$2e2bcd8739ae039)(this);
        this.filters = new (0, $0bfa6252c9fef6aa$export$2e2bcd8739ae039)(this);
        this.search = new (0, $3597ba39cfd0154a$export$2e2bcd8739ae039)(this);
        this.advancedSearch = new (0, $dbe8ea63d0c9ab70$export$2e2bcd8739ae039)(this);
        this.booksApi = new (0, $4QZXM.default);
        this.initializeBooks();
    }
    async initializeBooks() {
        const list = document.querySelector("#biblia-online .list");
        if (list) {
            list.classList.add("loader");
            this.booksApi.getBooks().then((data)=>{
                if (data.body) {
                    const body = data.body;
                    this.books.setBooksData(body);
                    body.forEach((item)=>this.books.createBook(list, item));
                    this.filters.initialize();
                    this.search.initialize();
                    this.chapter.setChapter(body[0]);
                    list.classList.remove("loader");
                    this.advancedSearch.setBooksSelect(body);
                }
            }).catch((error)=>console.error("Error:", error));
        }
    }
}



var $3lHCf = parcelRequire("3lHCf");
class $e018b642ef16e1c5$export$2e2bcd8739ae039 {
    constructor(calendar){
        this.handleDatePicker(calendar);
        this.handleDateElementUpdate(calendar);
        this.updateDateElement(calendar);
    }
    handleDatePicker(calendar) {
        const input = calendar.querySelector(".espiritualidade-date-picker");
        document.addEventListener("click", (e)=>{
            if (calendar.contains(e.target) && e.target !== input) {
                if (input.classList.contains("closed")) {
                    input.classList.remove("closed");
                    input.showPicker();
                } else input.classList.add("closed");
            } else input.classList.add("closed");
        });
    }
    handleDateElementUpdate(calendar) {
        const input = calendar.querySelector(".espiritualidade-date-picker");
        input.addEventListener("change", ()=>{
            input.classList.add("closed");
            this.updateDateElement(calendar);
        });
    }
    updateDateElement(calendar) {
        const input = calendar.querySelector(".espiritualidade-date-picker");
        const dayElement = calendar.querySelector("span.espiritualidade-date-day");
        let date;
        if (input.value) {
            const [year, month, day] = input.value.split("-").map(Number);
            date = new Date(year, month - 1, day, 12, 0, 0);
        } else date = new Date();
        if (date && dayElement) {
            const day = date.getDate().toString().padStart(2, "0");
            const weekday = this.getWeekDay(date);
            dayElement.innerText = `${day}, ${weekday}`;
        }
    }
    getWeekDay(date) {
        const weekDays = [
            "Domingo",
            "Segunda-feira",
            "Ter\xe7a-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "S\xe1bado"
        ];
        return weekDays[date.getDay()];
    }
}



class $360ba88aa174a798$export$2e2bcd8739ae039 {
    constructor(){
        this.handleContent();
        this.handleDataPicker();
        this.handleFontControllers();
        this.getGospelContent();
    }
    handleContent() {
        const calendar = document.querySelector("#evangelho-meditado .calendar input");
        calendar.addEventListener("change", ()=>{
            this.getGospelContent();
        });
    }
    getGospelContent() {
        const calendar = document.querySelector("#evangelho-meditado .calendar input");
        if (calendar && calendar.value) {
            let date = this.getSelectedDate(calendar.value, "-");
            const api = new (0, $3lHCf.default);
            this.setLoader();
            api.getMeditatedGospel(date).then((data)=>{
                if (data.body && data.body.posts[0]) {
                    const post = data.body.posts[0];
                    this.addContent(post);
                    this.addTitle(post);
                    this.addTumbnail(post);
                } else {
                    date = this.getSelectedDate(calendar.value, "/");
                    this.setNotFoundedContent(date);
                }
                this.clearLoader();
            });
        }
    }
    setNotFoundedContent(date) {
        const message = {
            content: `<strong>Nenhum resultado encontrado para o dia ${date}</strong>.`
        };
        this.addContent(message);
    }
    setLoader() {
        const calendar = document.querySelector("#evangelho-meditado .content");
        calendar.classList.add("deactive");
        const loader = document.querySelector("#evangelho-meditado .loader");
        loader.classList.remove("deactive");
    }
    clearLoader() {
        const calendar = document.querySelector("#evangelho-meditado .content");
        calendar.classList.remove("deactive");
        const loader = document.querySelector("#evangelho-meditado .loader");
        loader.classList.add("deactive");
    }
    addContent(post) {
        const content = document.querySelector("#evangelho-meditado .content-display .post-content");
        if (content) content.innerHTML = this.cleanDOMStyles(post.content);
    }
    cleanDOMStyles(content) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, "text/html");
        const elementsWithStyle = doc.querySelectorAll("[style]");
        elementsWithStyle.forEach((element)=>element.removeAttribute("style"));
        return doc.body.innerHTML;
    }
    addTitle(post) {
        const title = document.querySelector("#evangelho-meditado .content-title .title-content");
        if (title && post.title) {
            title.innerHTML = post.title;
            this.setTitleDay();
            title.classList.remove("deactive");
        } else title.classList.add("deactive");
    }
    addTumbnail(post) {
        const thumbnailContainer = document.querySelector("#evangelho-meditado .content-display .post-media .thumbnail");
        const thumbnail = document.querySelector("#evangelho-meditado .content-display .post-media .thumbnail > img");
        if (post.thumbnail && thumbnail) {
            thumbnail.setAttribute("src", post.title);
            thumbnailContainer.classList.remove("deactive");
        } else thumbnailContainer.classList.add("deactive");
    }
    setTitleDay() {
        const calendar = document.querySelector("#evangelho-meditado .calendar input");
        const [year, month, day] = calendar.value.split("-").map(Number);
        const date = new Date(year, month - 1, day, 12, 0, 0);
        const weekday = this.datapicker.getWeekDay(date);
        const titleDay = document.querySelector("#evangelho-meditado .content-title .title-week-day");
        if (titleDay) titleDay.innerText = weekday;
    }
    getSelectedDate(date, separator = "-") {
        let [year, month, day] = date.split("-").map(Number);
        day = String(day).padStart(2, "0");
        month = String(month).padStart(2, "0");
        return `${day}${separator}${month}${separator}${year}`;
    }
    handleDataPicker() {
        const calendar = document.querySelector("#evangelho-meditado .calendar");
        if (calendar) this.datapicker = new (0, $e018b642ef16e1c5$export$2e2bcd8739ae039)(calendar);
    }
    handleFontControllers() {
        const increaseButton = document.querySelector("#evangelho-meditado .font-controllers > .plus");
        const decreaseButton = document.querySelector("#evangelho-meditado .font-controllers > .minor");
        const content = document.querySelector("#evangelho-meditado .content-display > .post-content");
        this.fontControllers = new (0, $f54c35483bceabdf$export$2e2bcd8739ae039)(content, increaseButton, decreaseButton);
    }
}


class $10e609a78b4fb53e$var$Espiritualidade {
    constructor(){
        this.handleSections();
        this.handleUrlsParams();
        new (0, $e39be4a8c4aa2412$export$2e2bcd8739ae039)();
        new (0, $360ba88aa174a798$export$2e2bcd8739ae039)();
    }
    handleUrlsParams() {
        const params = new URLSearchParams(window.location.search);
        this.selectTab(params.get("tab"));
    }
    selectTab(param) {
        const section = document.querySelector(`#espiritualidade-content .heade-navigation > ul > li[data-section="${param}"]`);
        if (section) {
            this.cleanUpSections();
            section.classList.add("selected");
            this.showSelectedSection(param);
        }
    }
    handleSections() {
        const firstSection = document.querySelector("#espiritualidade-content .heade-navigation > ul > li");
        firstSection.classList.add("selected");
        this.showSelectedSection(firstSection.getAttribute("data-section"));
        const sections = document.querySelectorAll("#espiritualidade-content .heade-navigation > ul > li");
        sections.forEach((section)=>{
            section.addEventListener("click", ()=>{
                this.cleanUpSections();
                section.classList.add("selected");
                this.showSelectedSection(section.getAttribute("data-section"));
            });
        });
    }
    cleanUpSections() {
        const sections = document.querySelectorAll("#espiritualidade-content .heade-navigation > ul > li");
        sections.forEach((section)=>{
            section.classList.remove("selected");
        });
    }
    showSelectedSection(sectionId) {
        const sections = document.querySelectorAll(".espiritualidade-container > .sections > section");
        const section = document.querySelector(`#${sectionId}`);
        sections.forEach((section)=>{
            section.classList.add("deactive");
        });
        if (section) section.classList.remove("deactive");
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    const container = document.querySelector("#espiritualidade-content");
    if (container) new $10e609a78b4fb53e$var$Espiritualidade();
});

})();
//# sourceMappingURL=index.js.map
